import { Card, EmptyState } from "@/components/common";
import { BookOpen, ExternalLink } from "lucide-react";

// Compact read-only list of the resources shared with this person's role.
export function ResourceCards({ resources, title = "Resources for you", hint }) {
  const rows = resources || [];
  if (rows.length === 0) return null;
  return (
    <Card title={title} data-testid="resource-cards">
      {hint && <p className="text-sm text-zinc-500 mb-3">{hint}</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.map((r) => (
          <a key={r.id} href={r.url} target="_blank" rel="noreferrer"
            className="border rounded-lg px-3.5 py-3 hover:border-cc-blue transition-colors group" data-testid={`dash-resource-${r.id}`}>
            <div className="flex items-start gap-2.5">
              <BookOpen className="w-4 h-4 text-cc-blue mt-0.5 shrink-0" />
              <div className="min-w-0">
                <p className="text-sm font-semibold text-zinc-900 group-hover:text-cc-blue">{r.title}</p>
                {r.description && <p className="text-xs text-zinc-500 mt-0.5 line-clamp-2">{r.description}</p>}
                <span className="text-xs text-cc-blue inline-flex items-center gap-1 mt-1.5">Open <ExternalLink className="w-3 h-3" /></span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </Card>
  );
}
